// en/channel.js
export const channel = {
  header: {
    title: "Buchungskanäle",
    subtitle: "Synchronisieren oder verwalten Sie Booking.com, Expedia, Airbnb und viele mehr.",
  },

  establishedConnections: "Bestehende Verbindungen",

  common: {
    loading: "Wird geladen...",
    configure: "Konfigurieren",
    close: "Schließen",
    comingSoon: "Demnächst",
  },

  alerts: {
    bullets: {
      choosePlan: "Wählen Sie einen Tarif und aktivieren Sie Ihren Channel Manager.",
      completeProperty: "Vervollständigen Sie die Einrichtung Ihrer Unterkunft im Dashboard.",
    },
    title: "Aktion erforderlich",
    planRequired:
      "Sie benötigen einen aktiven Tarif, um Ihre Unterkunft mit einer OTA zu verknüpfen.",
    missingPropertyChannel:
      "Um sich mit einer OTA zu verbinden, müssen Sie zuerst die Einrichtung Ihrer Unterkunft im Channel Manager abschließen.",
  },

  modal: {
    channelHeader: "Kanalverbindung mit {channel}",
  },

  web: {
    cardTitle: "Direktbuchungen über die Website",
    // NEW: description for the OTA-style card
    cardDescription:
      "Erhalten Sie Direktbuchungen über Ihre Website ohne OTA-Provisionen.",
    // NEW: button texts for card and table
    manageCta: "Verwalten",
    configureCta: "Konfigurieren",
    // NEW: label for the ID column of the direct bookings row
    directLinkLabel: "Link für Direktbuchungen",

    linkShareMessage: "Hallo 👋 Über diesen Link können Sie buchen:\n\n{link}",
    modalTitle: "Direktbuchungen über die Website",
    description:
      "Aktivieren oder deaktivieren Sie die für die Direktbuchung auf Ihrer Website verfügbaren Optionen. Gäste können ohne Zwischenhändler direkt buchen.",
    toggleAllDesktop: "Alle Webbuchungen aktivieren/deaktivieren",
    toggleAllMobile: "Aktivieren/Deaktivieren",
    table: {
      name: "Name",
      available: "Für Webbuchung verfügbar",
    },
    capacity: "Kapazität",
    people: "Personen",
    empty: "Keine Einträge gefunden",

    // Link section
    linkTitle: "Ihr Link für Direktbuchungen",
    linkHelp: "Teilen Sie diesen Link, damit Ihre Gäste direkt buchen können",
    linkCopyTooltip: "Link kopieren",
    linkShareWhatsappTooltip: "Über WhatsApp teilen",
  },

  plan: {
    title: "Aktivieren Sie Ihren Tarif, um sich zu verbinden",
    subtitle:
      "Wählen Sie den Tarif, der zu Ihren Anforderungen passt, und aktivieren Sie die Verbindung mit Booking, Airbnb, Expedia und mehr.",
    hint: "Sobald Sie ein Abo abgeschlossen haben, kommen Sie hierher zurück; wir schalten alle Kanäle frei, mit denen Sie sich verbinden können.",
    cta: "Tarif upgraden",
  },

  toasts: {
    paymentTypeUpdated: "Zahlungsmethode erfolgreich aktualisiert",
    linkCopiedTitle: "Kopiert!",
    linkCopiedBody: "Link erfolgreich kopiert",
    linkCopyErrorTitle: "Fehler",
    linkCopyErrorBody: "Beim Kopieren des Links ist ein Fehler aufgetreten",
    save: "Fehler beim Speichern der Konfiguration",
    updateWebReservation: "Fehler beim Aktualisieren der Webbuchung",
    saved: "Konfiguration erfolgreich gespeichert",
    updateWebReservationsGlobal:
      "Globaler Status der Direktbuchungen erfolgreich aktualisiert",
  },

  errors: {
    loadData: "Fehler beim Laden der Daten. Bitte versuchen Sie es erneut.",
    generateToken: "Fehler beim Erzeugen des Tokens",
    connectChannel: "Fehler beim Verbinden mit dem Kanal. Bitte versuchen Sie es erneut.",
    updatePaymentType: "Fehler beim Aktualisieren der Zahlungsmethode",
    save: "Fehler beim Speichern der Konfiguration",
    updateWebReservation: "Fehler beim Aktualisieren der Webbuchung",
  },

  tabs: {
    reservations: "Buchungsstatus",
    payments: "Preise & Zahlungen",
    share: "Teilen",
  },

  payments: {
    title: "Wie möchten Sie Zahlungen für Direktbuchungen erhalten?",
    onArrival: {
      label: "Zahlung vor Ort",
      desc: "Gäste zahlen direkt bei der Ankunft",
    },
    online: {
      label: "Online-Vorauszahlung",
      desc: "Gäste zahlen bei der Buchung",
    },
  },

  discounts: {
    sectionTitle: "Rabatt für Direktbuchungen konfigurieren",
    toggle: "Rabatt auf Direktbuchungen anwenden",
    typeTitle: "Rabattart:",
    percentage: {
      label: "Prozentualer Rabatt",
      desc: "Einen prozentualen Rabatt anwenden",
    },
    fixed: {
      label: "Rabatt als Festbetrag",
      desc: "Einen festen Betrag als Rabatt anwenden",
    },
    valueTitle: "Rabattwert:",
    placeholderPercentage: "Z. B.: 10",
    placeholderFixed: "Z. B.: 50.00",
    helpPercentage:
      "Geben Sie einen Wert zwischen 1 und 100 für den Rabattprozentsatz ein",
    helpFixed: "Geben Sie den festen Betrag in Euro ein, der vom Gesamtbetrag abgezogen wird",
    previewTitle: "Vorschau:",
    previewPercentage: "Auf Direktbuchungen wird ein Rabatt von {value}% angewendet",
    previewFixed: "Auf Direktbuchungen wird ein Rabatt von {value} € angewendet",
  },

  buttons: {
    saveChanges: "Änderungen speichern",
  },
};
